import React from 'react';

type Props = {
  expanded: boolean;
  onToggle: () => void;
};

export const ToggleExpandButton: React.FC<Props> = ({ expanded, onToggle }) => (
  <button
    type="button"
    className="rte-richtext-toggle"
    data-expanded={expanded ? 'true' : 'false'}
    onClick={onToggle}
  >
    <i className={`iconfont ${expanded ? 'icon-shouqi1' : 'icon-zhankai2'}`} />
    <span className="rte-richtext-toggle-label">{expanded ? '收起' : '展开'}</span>
  </button>
);
